import React from 'react';

import {hooks} from '../hooks';
import {svg} from '../assets/svg';
import {TabScreens} from '../routes';
import {actions} from '../store/actions';
import { usePermission } from '../hooks/usePermission';

const tabs = [
  {
    id: 1,
    screen: TabScreens.Home,
    icon: <svg.HomeTabSvg />,
  },
  {
  id: 2,
  screen: TabScreens.Admin,
  icon: <svg.AdminTabSvg />,
  },
  {
    id: 3,
    screen: TabScreens.History,
    icon: <svg.SearchTabSvg />,
  },
  // {
  //   id: 3,
  //   screen: TabScreens.FeeDetails,
  //   icon: <svg.OrderTabSvg />,
  // },
  // {
  //   id: 4,
  //   screen: TabScreens.Academy,
  //   icon: <svg.HeartTabSvg />,
  // },
  {
    id: 4,
    screen: TabScreens.Notification,
    icon: <svg.BellTabSvg />,
  },
];

export const Footer: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();
  const { canIndex } = usePermission('patrol_group_index');

const storedRoles = localStorage.getItem('userRole');
let userRoles: string[] = [];

if (storedRoles) {
  try {
    const parsed = JSON.parse(storedRoles);
    if (Array.isArray(parsed)) userRoles = parsed;
  } catch {
    userRoles = [];
  }
}


const filteredTabs = tabs.filter(tab => {
  if (tab.screen === TabScreens.Admin) {
    return canIndex;
  }
  return true;
});

  return (
    <section
      style={{
        padding: 20,
        // backgroundColor: 'var(--main-turquoise, #00b0b9)',
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      <footer
        style={{
          zIndex: 100,
          borderRadius: 10,
          height: 'var(--footer-height)',
          // backgroundColor: 'var(--white-color)',
          backgroundColor: 'rgba(35, 186, 194, 0.2)',
        }}
      >
        <ul
          style={{height: '100%'}}
          className='row-center-space-around'
        >
          {filteredTabs.map((tab, index) => {
            return (
              <li
                key={tab.id}
                className='clickable center'
                style={{
                  height: '100%',
                  width: 'calc(100% / 5)',
                  borderRadius: 10,
                }}
                  onClick={() => {
                    dispatch(actions.setScreen(tab.screen));
                    navigate('/tab-navigator', { replace: true });
                  }}


              >
                {tab.icon}
              </li>
            );
          })}
        </ul>
      </footer>
    </section>
  );
};